<template>
  <div>
    <div style="display:flex;align-items:center;flex-direction:column;justify-content:center;color:#757575;">
      <half-circle-spinner :animation-duration="1000" :size="90" :color="'#033873'" />
    </div>
  </div>
</template>

<script>
  import { HalfCircleSpinner } from 'epic-spinners'

  export default {
    name: 'loading',
    components: {
      HalfCircleSpinner
    },
    data () {
      return {}
    },
    created () {},
    methods: {

    },
    computed: {

    },
    destroyed () {}
  }
</script>


// WEBPACK FOOTER //
// src/components/views/loadingView.vue